module.exports = __webpack_public_path__ + "static/media/luoshan_package.bf1e7da7.webp";